module.exports = __webpack_public_path__ + "static/img/partner_with_leaders.399b715.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/partner_with_leaders.png
// module id = 784
// module chunks = 5